import { render, staticRenderFns } from "./PalmsType.html?vue&type=template&id=56e184c0&external"
import script from "./PalmsType.js?vue&type=script&lang=js&external"
export * from "./PalmsType.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports